module.exports = __webpack_public_path__ + "static/media/logo11.fe2e13ca.JPG";